import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// Storage is optional - only import if needed
// import { getStorage } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // storageBucket is optional - only needed if using Firebase Storage
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Check if environment variables are properly set
if (!firebaseConfig.apiKey || !firebaseConfig.authDomain || !firebaseConfig.projectId) {
  console.error('Missing Firebase environment variables');
  console.error('Please check your .env file contains:');
  console.error('REACT_APP_FIREBASE_API_KEY=your_api_key');
  console.error('REACT_APP_FIREBASE_AUTH_DOMAIN=your_auth_domain');
  console.error('REACT_APP_FIREBASE_PROJECT_ID=your_project_id');
  console.error('REACT_APP_FIREBASE_STORAGE_BUCKET=your_storage_bucket (optional)');
  console.error('REACT_APP_FIREBASE_MESSAGING_SENDER_ID=your_messaging_sender_id');
  console.error('REACT_APP_FIREBASE_APP_ID=your_app_id');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
// Storage is optional - only initialize if storageBucket is provided
// export const storage = getStorage(app);

export default app;

